import type {
  DocumentRequestResponse,
  DocumentRequestsResponse,
  FulfilDocumentRequestPayload,
} from '@gokrew/models/documents';
import api from './client';

const endpoints = {
  list: '/employee/document-requests',
  fulfil: (requestId: string) =>
    `/employee/document-requests/${requestId}/fulfil`,
};

/** The documents HR asked me for, open first. */
export async function getMyDocumentRequests() {
  const { data } = await api.get<DocumentRequestsResponse>(endpoints.list);
  return data;
}

/**
 * Answers a request with an already uploaded file: it lands in my documents
 * under the requested type and the request closes.
 */
export async function fulfilDocumentRequest(
  requestId: string,
  payload: FulfilDocumentRequestPayload
) {
  const { data } = await api.post<DocumentRequestResponse>(
    endpoints.fulfil(requestId),
    payload
  );
  return data;
}
